import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import ValuePropositionSelect from './common_components/ValuePropositionSelect';
import LocaleStore from './common_components/localization/LocaleStore';

export default class TooltipsERB extends React.Component {
  constructor(props) {
    super(props);

    this.localeStore = new LocaleStore(props.locale, []);
  }

  render() {
    return (
      <BrowserRouter>
        <IntlProvider
          locale={this.localeStore.locale}
          messages={this.localeStore.messages}
        >
          <ValuePropositionSelect {...this.props} />
        </IntlProvider>
      </BrowserRouter>
    );
  }
}
